import { jsx as _jsx } from "react/jsx-runtime";
import { SignalAgentsRemote } from 'components/pages/signal-agents-remote';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
export const signalAgentsRoutes = [
    {
        path: ROUTE_PATHS.SIGNAL_AGENTS,
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(SignalAgentsRemote, {})
                })
            },
            {
                path: ROUTE_PATHS.MATCH_ALL,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(SignalAgentsRemote, {})
                })
            }
        ]
    }
];
